// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { bannerStyles } from "@awc/Overrides/Widgets/Basic/Banner";
import { color } from "@awc/XDL/Utilities";
import { css } from "styled-components";

bannerStyles.linkClickable = {
    css: css`
        &:not(.has-link) {
            cursor: auto;
        }
        &.has-link {
            box-shadow: 0 1px 3px 2px transparent;
            transition: box-shadow 200ms ease-in-out;
            &:hover {
                box-shadow: 0 1px 3px 2px ${color("primary.main", 0.35)};
            }
        }
    `,
};

bannerStyles.img = {
    css: css`
        width: 100%;
        height: auto;
        img {
            max-width: 100%;
            max-height: 100%;
        }
    `,
};

bannerStyles.overlayWrapper = {
    css: css`
        width: 100%;
        color: white;
        text-align: center;
        position: relative;
    `,
};

bannerStyles.slideCenteringWrapperStyles = {
    css: css`
        &.background-image {
            padding: 16px;
            position: absolute;
            top: 0;
        }
    `,
};
